<template>
  <div class="pt-0 pl-0 pr-0 accordion" role="tablist">

    <b-nav-item
        class="nav-link py-0 px-md-0"
        style="margin-left: 1px"
        :id="section.id"
        :data-test-path="section.id"
        link-classes="text-primary"
        href=""
        v-if="section.hasPermission && section.items"
        @click.stop="openClose"
        @mousedown.stop=""
        @mouseup.stop="">
        <div class="nav-item-inner">
          <div class="has-sub-menu-inner">
            <div class="nav-item-icon" style="font-size: 19px;" >
              <font-awesome-icon :icon="section.icon" class="mr-2"/>
            </div>
            <div class="nav-item-label" style="margin-left: 2px;">
              {{ section.label }}
            </div>
          </div>
          <div class="nav-item-last-icon">
            <font-awesome-icon :icon="icon" class="ml-2"/>
          </div>
        </div>

    </b-nav-item>

    <b-collapse :id="section.accordionId" v-model="sectionOpen" role="tabpanel" :data-test-path="section.id">
      <b-card-body class="py-1 bg-light">
        <div v-for="menuItem in section.items" :key="menuItem.id">

          <b-nav-item
              class="nav-link py-0 px-md-0"
              :id="menuItem.id"
              :data-test-path="menuItem.id"
              link-classes="text-primary"
              href=""
              v-if="menuItem.hasPermission && !menuItem.items"
              @click="execute(menuItem)">
            <div class="nav-item-inner">
              <div class="nav-item-icon">
                <font-awesome-icon :icon="menuItem.icon" class="mr-2"/>
              </div>
              <div class="sub-menu-nav-item-label">
                {{ menuItem.label }}
              </div>
            </div>
          </b-nav-item>
          <sub-menu ref="subMenu" v-if="menuItem.hasPermission && menuItem.items" :section="menuItem" :parent="parent">

          </sub-menu>


        </div>
      </b-card-body>
    </b-collapse>
  </div>
</template>

<script>
import {parseIconName} from "@/FontAwesomeSetup";

export default {
  name: "SubMenu",
  props: {
    section: {},
    offset: {default: 10},
    parent: {default: null},
  },
  created() {
  },

  methods: {

    closeSubMenu(idToKeep) {

      let itemFound = false;
      if(this.$refs.subMenu){
        for (let subMenu of this.$refs.subMenu) {
          itemFound = subMenu.closeSubMenu(idToKeep) || itemFound;
        }
      }
      if (itemFound) {
        return true;
      }
      if (this.section.id === idToKeep) {
        return true;
      } else {
        this.icon = "angle-right";
        this.collapse();
      }
    },

    openClose(event) {
      this.sectionOpen = !this.sectionOpen;
      if (this.sectionOpen) {
        this.parent?.closeOtherSubMenus(this.section, this.parent);
        this.icon = "angle-down";
      } else {
        this.icon = "angle-right";
      }
      event.stopImmediatePropagation();

      return false;
    },
    collapse() {
      this.sectionOpen = false;
    },


    execute(val) {
      // this.$parent.sampleMethod();
      this.$emit('run-execute', val)
    },

  },

  watch: {
    "section.open": function (val) {
      this.sectionOpen = val;
    },

  },

  data: function () {
    return {
      sectionOpen: this.section.open,
      icon: "angle-right"
    }
  }
}
</script>

<style scoped>

</style>